export default {
  home: {
    title: 'PRODUCT OPTION'
  },
  foot: {
    title: 'Century Games Players',
    p1: 'Enter your User ID, select your "Recharge", pay, and then the items will be shown in your charged account <span style="color: #58a8a5;">after you reload the game.</span>',
    p2: 'If you have any questions, please feel free to contact customer support. Thanks for your support!',
    copyright: '© Copyright 2024 Century Games.'
  },
  accept: {
    title: 'This website uses cookies to make your browsing experience better. Please read our <a href="https://www.centurygames.com/privacy-policy/" style="color: #58a8a5;">Privacy Policy</a>  for information about what information we collect on our site. By continuing to use this site, you agree that we may store and access cookies on your device.',
    decline: 'Decline',
    accept: 'Accept'
  },
  game: {
    inapptext:'Or Login via Game',
    loginfail:'Login Failed',
    logintip:'If authorization fails in the game, please upgrade the game to the latest version or try accessing it using another browser.',
    reloadmsg:"Please click 'Reload' to retrieve the login result.",
    reload:"Reload",
    appnotice:'If you want to log in through the game app, please use an external browser to open the store.',
    findid:"Couldn't find your User ID?",
    changeaccount:'Are you sure you want to log out of your account?',
    login:'Log In',
    notice:'Notice',
    confirm:'Confirm',
    loginuserid:'User ID',
    palceholder:'Enter User ID',
    okbtn:'OK',
    loginbtn:'Login via Game',
    changebtn:'Or Login with User ID',
    useTitle: 'ACCOUNT',
    checkBtn: 'Check',
    checktext: 'Normally find in the settings, or tap the question mark for guidance.',
    username: 'Name : ',
    userId: 'User ID : ',
    edit: 'Edit',
    packageTitle: 'SELECT RECHARGE',
    paymentTitle: 'SELECT PAYMENT',
    total: 'Total',
    goPay: 'Pay now',
    noSelectPackageTips: "You didn't select anything",
    payFail: 'PAYMENT FAILURE',
    payFailTips1: 'Please contact',
    payFailTips2: 'Customer Support',
    deliveryFail: 'DELIVERY FAILURE',
    deliveryFailTips: 'Please contact Customer Support',
    paySuccess: 'PAYMENT SUCCESS',
    paySuccessTips: 'Please wait a moment for delivery',
    paySuccessTips2: 'Remember to reload the game !',
    orderTitle: 'Your order summary',
    paidWith: 'Paid with',
    orderID: 'Order ID',
    transactionId: 'Transaction ID',
    payStatus: 'Payment status',
    orderTotal: 'Total Price',
    transactionDate: 'Transaction date',
    camelPayfail: 'Payment failure',
    camelPaySuccess: 'Payment success',
    camelDeliveryFail: 'Delivery failure',
    goOnPay: 'Make another purchase',
    getInvoice: 'Get Invoice',
    confirmOrder: 'CONFIRM THE ORDER',
    confirmFollow: 'Please confirm the following:',
    nickname: 'Nickname',
    packageName: 'Items',
    totalPayment: 'Total payment',
    confirmPayWith: 'Pay with',
    confirmAndGoOn: 'Confirm and go to pay',
    orderCancel: 'Cancel',
    getInvoiceTitle: 'GET INVOICE',
    getInvoiceTips: 'If you would like a receipt of the purchase by email, please enter an email address.',
    getInvoiceTips1: 'Enter email to get invoice',
    getInvoiceTips2: 'Agree to our collection and storage of your email address.',
    getInvoiceTips3: 'Agree that we could send discounts, promotion and more about our games information to you via email.',
    invoiceSend: 'Send',
    sendSuccess: 'Sent Successfully',
    id404: 'ID not found',
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js